import React, { useState } from 'react';

const PFEsiReturnsFiling = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with PF & ESI Returns Filing.',
    website_hp: ''
  });

 const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with PF & ESI Returns Filing.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              PF & ESI Returns Filing
            </h1>

            <p className="mt-4 text-xl text-blue-100">
              Comprehensive Provident Fund (PF) and Employees' State Insurance (ESI) return filing services to ensure your business stays compliant with statutory regulations. We handle monthly filings, challan generation, and compliance management for both schemes.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">🛡️</span> Ensure Statutory Compliance
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Filing Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of PF & ESI Returns Filing
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Provident Fund (PF) and Employees' State Insurance (ESI) are crucial statutory compliance requirements for businesses in India. PF ensures retirement benefits for employees, while ESI provides health insurance and medical benefits.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Monthly return filing for both PF and ESI is mandatory for eligible establishments. Timely filing ensures compliance, avoids penalties, and maintains employee welfare benefits while protecting your business from legal consequences.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our comprehensive service covers both PF and ESI compliance, including registration, monthly calculations, challan generation, return filing, and compliance advisory services.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Statutory Compliance:</strong> Ensure full compliance with EPFO and ESIC regulations to avoid penalties and legal issues.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Timely Filing:</strong> Monthly filing before due dates (15th for PF, 15th/21st for ESI) to prevent late fees.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Dual Scheme Management:</strong> Comprehensive handling of both PF and ESI compliance under one service.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Employee Welfare:</strong> Ensure continuous benefits for your employees including retirement and health coverage.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Online Portal Expertise:</strong> Expert handling of EPFO Unified Portal and ESIC portal for seamless filing.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Payment Processing:</strong> Complete challan generation and payment processing for both schemes.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Compliance Monitoring:</strong> Continuous tracking of regulatory changes and filing deadlines.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with PF & ESI Returns Filing." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Comprehensive Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for PF & ESI Returns Filing
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 grid-flow-row-dense">
            {[
              { number: "01", icon: "👥", title: "Employee Data Collection", desc: "Gather monthly employee data including salaries, attendance, and membership details for PF & ESI." },
              { number: "02", icon: "🧮", title: "Contribution Calculation", desc: "Calculate employer and employee contributions for both PF (12% each) and ESI (3.25% & 0.75%)." },
              { number: "03", icon: "📝", title: "Return Preparation", desc: "Prepare PF Form 5, 10, 12A, and ESI Form 6 with accurate employee and contribution details." },
              { number: "04", icon: "💳", title: "Challan Generation", desc: "Generate payment challans for both PF and ESI contributions through respective portals." },
              { number: "05", icon: "💰", title: "Payment Processing", desc: "Process payments through designated banks or online banking for both PF and ESI contributions." },
              { number: "06", icon: "📤", title: "Online Return Filing", desc: "File returns through EPFO Unified Portal and ESIC portal with payment acknowledgements." },
              { number: "07", icon: "🔍", title: "Verification & Reconciliation", desc: "Verify filed returns, reconcile payments, and ensure accurate posting in employee accounts." },
              { number: "08", icon: "🏆", title: "Compliance Certificate", desc: "Provide filing acknowledgements, payment receipts, and monthly compliance certificates." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 flex flex-col justify-between p-3 bg-white rounded-xl shadow-md text-center hover:shadow-lg transition-shadow border-t-4 border-blue-500">
                <div className="flex flex-col flex-grow justify-center">
                  <span className="text-xl font-extrabold text-blue-600 block leading-tight">{step.number}</span>
                  <span className="text-2xl mx-auto block leading-none">{step.icon}</span>
                  <h3 className="text-base font-semibold text-gray-900 leading-snug mt-0.5">{step.title}</h3>
                  <p className="text-gray-600 text-sm text-justify mt-1 leading-snug">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Documents Required for PF & ESI Filing
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Mandatory Documents for Monthly Compliance
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "🆔", title: "PF & ESI Registration", desc: "PF Establishment Code and ESI Registration Number certificates." },
              { icon: "👥", title: "Employee Master Data", desc: "Employee details including UAN, ESI IP numbers, and joining dates." },
              { icon: "💵", title: "Monthly Salary Register", desc: "Detailed salary breakdown with basic wages, allowances, and deductions." },
              { icon: "📊", title: "Attendance Records", desc: "Monthly attendance and leave records for contribution calculation." },
              { icon: "📄", title: "Previous Returns", desc: "Last filed PF and ESI returns for continuity and reference." },
              { icon: "🏦", title: "Bank Account Details", desc: "Company bank account information for payment processing." },
              { icon: "➕", title: "New Joinee Documents", desc: "Documents for new employees requiring PF/ESI registration." },
              { icon: "👋", title: "Exit Employee Details", desc: "Details of employees who left during the month for final settlements." },
              { icon: "✉️", title: "Authorization Letter", desc: "Authorization for consultant to file returns on company's behalf." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1 text-justify">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>

          {/* 5 equal boxes in a single row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              { icon: "✅", title: "Filed Return Acknowledgements", desc: "Monthly filing acknowledgements for both PF (ECR) and ESI returns from respective portals." },
              { icon: "💳", title: "Payment Challans & Receipts", desc: "Complete set of payment challans and bank receipts for both PF and ESI contributions." },
              { icon: "📋", title: "Monthly Compliance Reports", desc: "Detailed compliance reports showing calculations, filings, and payment status for both schemes." },
              { icon: "📅", title: "Compliance Calendar", desc: "Monthly compliance calendar with PF (15th) and ESI (15th/21st) filing deadlines." },
              { icon: "🎧", title: "Ongoing Support Services", desc: "Monthly reminder services, regulatory updates, employee query resolution, annual return filing support" }
            ].map((item, index) => (
              <div key={index} className="p-5 bg-white rounded-xl shadow-lg border-l-4 border-green-500 flex flex-col h-full">
                <span className="text-2xl mb-2 block">{item.icon}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-snug">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                  <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                      Common Questions
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      PF & ESI Returns Filing FAQs
                  </p>
              </div>
              
              <div className="space-y-4 max-w-4xl mx-auto">
                {[
                  { 
                    question: "What are the due dates for PF and ESI filing?", 
                    answer: "PF returns are due by the 15th of the following month. ESI returns have two due dates: 15th for contributions and 21st for electronic challan submission." 
                  },
                  { 
                    question: "What are the current contribution rates?", 
                    answer: "PF: 12% each from employer and employee. ESI: 3.25% from employer and 0.75% from employee (on wages up to ₹21,000)." 
                  },
                  { 
                    question: "When is PF and ESI registration mandatory?", 
                    answer: "PF: For establishments with 20+ employees. ESI: For establishments with 10+ employees (in most states) with wages up to ₹21,000 per month." 
                  },
                  { 
                    question: "What are the penalties for late filing?", 
                    answer: "PF: Interest @ 12% p.a. + damages. ESI: Interest @ 12% p.a. + penalties up to twice the amount due for delayed payment." 
                  },
                  { 
                    question: "Can we file returns for multiple establishments?", 
                    answer: "Yes, we handle PF and ESI compliance for multiple establishments, branches, and locations under one comprehensive service." 
                  },
                  { 
                    question: "What is the wage ceiling for PF and ESI?", 
                    answer: "PF: No ceiling, but contributions are calculated on basic wages up to ₹15,000. ESI: Applicable for employees with wages up to ₹21,000 per month." 
                  }
                ].map((faq, index) => (
                  <div key={index} className="border rounded-lg p-5 shadow-sm">
                    <h4 className="font-semibold text-lg text-gray-900 mb-2">{faq.question}</h4>
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                ))}
              </div>
          </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-white">
                Ready for PF & ESI Compliance?
            </h2>
            <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
                Let our team of statutory compliance experts handle your PF and ESI obligations seamlessly.
            </p>
            <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                <span className="mr-2">📞</span> Consult Our Compliance Expert Today
            </a>
        </div>
      </section>
    </main>
  );
};

export default PFEsiReturnsFiling;